export const MANAGED_TARGETING_KEYS = Object.freeze([
  "sd_publication",
  "sd_edition",
  "sd_placement",
  "sd_page_type",
  "sd_consent"
]);

function safeValue(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return /^[a-z0-9][a-z0-9_.-]{0,79}$/.test(normalized) ? normalized : null;
}

export function buildManagedTargeting(input = {}) {
  const candidates = {
    sd_publication: input.publicationCode,
    sd_edition: input.editionCode || "default",
    sd_placement: input.placementIdentifier,
    sd_page_type: input.pageType || "unknown",
    sd_consent: input.consentState || "unknown"
  };
  return Object.fromEntries(MANAGED_TARGETING_KEYS.map(key => [key, safeValue(candidates[key])]).filter(([, value]) => value));
}

export function validateManagedTargeting(input = {}) {
  const unknown = Object.keys(input).filter(key => !MANAGED_TARGETING_KEYS.includes(key));
  if (unknown.length) throw new Error("Unmanaged advertising targeting key.");
  return Object.fromEntries(Object.entries(input).map(([key, value]) => [key, safeValue(value)]).filter(([, value]) => value));
}
